import { BrowserRouter as Router, Route, Routes, useLocation, Navigate, } from "react-router-dom";
import Login from "../pages/auth/Login";
import Signup from "../pages/auth/Signup";
import Forget from "../pages/auth/Forget";
import Dashboard from "../pages/adminPortal/Dashboard/index.js";
import Vechical from "../pages/adminPortal/vehicles/index.js";
import AddVehicle from "../pages/adminPortal/vehicles/Add.jsx";
import Customer from "../pages/adminPortal/customer/index.js";
import ViewCustomer from "../pages/adminPortal/customer/View.jsx";
import BlForm from "../pages/adminPortal/blform/index";
import Quotation from "../pages/adminPortal/quotation/index.js";
import QuotationView from "../pages/adminPortal/quotation/View.jsx";
import Vendors from "../pages/adminPortal/vendors/index.js";
import VendorQuotation from "../pages/adminPortal/vendorquotation/View.jsx";
import BrowseVendor from "../pages/adminPortal/vendorquotation/index.js";
import VendorQuotationForm from "../pages/adminPortal/vendorquotation/Form.jsx";
import VendorForm from "../pages/adminPortal/vendors/Form.jsx";
import ViewVendor from "../pages/adminPortal/vendors/View.jsx";
import Employees from "../pages/adminPortal/employees/index.js";
import EmployeeForm from "../pages/adminPortal/employees/Form.jsx";
import ViewEmployee from "../pages/adminPortal/employees/View.jsx";
import TowingTariff from "../pages/adminPortal/towingtariff/index.js";
import CreditNotes from "../pages/adminPortal/accounts/childfolder/CreditNotes/index.js";
import DebitNotes from "../pages/adminPortal/accounts/childfolder/DebitNotes/index.js";
import ReceiptCollect from "../pages/adminPortal/accounts/childfolder/InvoiceReceipt/index.js";
import AddRecepit from "../pages/adminPortal/accounts/childfolder/InvoiceReceipt/AddRecepit.jsx";
import Coasting from "../pages/adminPortal/accounts/childfolder/CostingExpenses/index.js";
import AddCoastngExpenses from "../pages/adminPortal/accounts/childfolder/CostingExpenses/EditCostingExpenses.jsx";

import PaymentVoucher from "../pages/adminPortal/accounts/childfolder/PaymentVoucher/index.js";
import ExpenseVoucher from "../pages/adminPortal/accounts/childfolder/ExpenseVoucher/index.js";
import VendorPaymentList from "../pages/adminPortal/accounts/childfolder/VendorPaymentList.jsx";
import VendorContainerPayment from "../pages/adminPortal/accounts/childfolder/VendorContainerPayment.jsx";
import Setting from "../pages/adminPortal/setting/Setting.jsx";
import ContainerSize from "../pages/adminPortal/setting/ContainerSize.jsx";
import Log from "../pages/adminPortal/setting/Log.jsx";
import Invoice from "../pages/adminPortal/invoices/index.js";
import LoadingPlan from "../pages/adminPortal/loadingplan/index.js";
import LoadingImo from "../pages/adminPortal/loadingimo/index.js";
import LoadingClient from "../pages/adminPortal/loadingclient/index.js";
import EditSavePlan from "../pages/adminPortal/loadingsaveplan/Edit.jsx";
import EditLoadingPlan from "../pages/adminPortal/loadingplan/Edit.jsx";
import LoadingVehicleDetail from "../pages/adminPortal/loadingplan/LoadingVehicleDetail.jsx";
import LoadingAdd from "../pages/adminPortal/loadingplan/LoadingAdd.jsx";
import GenerateLoadPlan from "../pages/adminPortal/loadingplan/GenerateLoadPlan.jsx";
import ViewLoadingPlan from "../pages/adminPortal/loadingclient/View.jsx";
import SaveContainer from "../pages/adminPortal/loadingsaveplan/index.js";
import DockReceipt from "../pages/adminPortal/blform/View.jsx";
import Email from "../pages/adminPortal/headericon/Email.jsx";
import EditProfile from "../pages/adminPortal/headericon/EditProfile.jsx";
import AuthLayout from "../layout/auth";
import MainLayout from "../layout";
import CustomerForm from "../pages/adminPortal/customer/Form.jsx";
import QuotationForm from "../pages/adminPortal/quotation/Form.jsx";
import Ledger from "../pages/adminPortal/accounts/childfolder/Ledger.jsx";
import AddInvoice from "../pages/adminPortal/invoices/add.jsx";
import Reports from "../pages/adminPortal/report/index.js";
import EditInvoice from "../pages/adminPortal/invoices/Edit.jsx";
import InvoiceView from "../pages/adminPortal/invoices/view.jsx";
import BrowseTranscation from "../pages/adminPortal/accounts/childfolder/BrowseTranscation.jsx";
import Accounts from "../pages/adminPortal/accounts/index.js";
import OpeningBalances from "../pages/adminPortal/accounts/OpeningBalance/OpeningBalances.jsx";
import EditOpeningBalances from "../pages/adminPortal/accounts/OpeningBalance/EditOpeningBalances.jsx";
import CashVoucher from "../pages/adminPortal/accounts/CashVoucher.jsx";
import BankVoucher from "../pages/adminPortal/accounts/BankVoucher.jsx";
import JournalVoucher from "../pages/adminPortal/accounts/JournalVoucher.jsx";
import PNL from "../pages/adminPortal/accounts/childfolder/PNL.jsx";
import Appointments from "../pages/adminPortal/appointments/index.js";
import ViewAppointments from "../pages/adminPortal/appointments/View.jsx";
import AddAppointment from "../pages/adminPortal/appointments/Add";
import VehicleEdit from "../pages/adminPortal/vehicles/Edit.jsx";
import InventoryReport from "../pages/adminPortal/invetoryreport/index.js";

import {
  AtVehicle,
  AtVehicleWithoutKey,
  AtVehicleWithoutTitle,
  CreateLoadPlans,
  CustomerAppointments,
  CustomerDashbroad,
  CustomerInvoices,
  CustomerLedger,
  CustomerVechical,
  Loadedplan,
  LoadedVehicle,
  OpenSaveplan,
  OtherVehicles,
  SendLoadPlan,
  VehicleLoadPlan,
  VehicleWithBOS
} from "../pages/customerPortal/index.js";
import TermAndCondition from "../pages/auth/TermAndCondition.jsx";
import ImoEdit from "../pages/adminPortal/loadingimo/Edit.jsx";
import ImoView from "../pages/adminPortal/loadingimo/View.jsx";
import AccountsCustomerLedger from "../pages/adminPortal/accounts/childfolder/CustomerBalance.jsx";
import MonthlyCashFlow from "../pages/adminPortal/report/MonthlyCashFlow.jsx";
import Capital from "../pages/adminPortal/accounts/Capital.jsx";
import { ROLES } from "../constants/index.js";
import { useEffect, useState } from "react";
import Edit from "../pages/adminPortal/blform/Edit.jsx";
import LoadPlanPdf from "../pages/adminPortal/loadingplan/LoadPlanPdf.jsx";
import Add from "../pages/adminPortal/blform/add-doc.jsx";
import User from "../pages/adminPortal/staff/user/index.js";
import Role from "../pages/adminPortal/staff/roles/index.js";
import Permissions from "../pages/adminPortal/staff/roles/Permissions.jsx";
import StaffCustomer from "../pages/adminPortal/staff/Customer.jsx";
import ResetPassword from "../pages/auth/ResetPassword.jsx";
import VoucherPDF from "../pages/adminPortal/accounts/childfolder/ExpenseVoucher/VoucherPDF.jsx";
import DebitPDF from "../pages/adminPortal/accounts/childfolder/DebitNotes/debitPDF.jsx";
import PaymentPDF from "../pages/adminPortal/accounts/childfolder/PaymentVoucher/PaymentPDF.jsx";
import CreditPDF from "../pages/adminPortal/accounts/childfolder/CreditNotes/creditPDF.jsx";
import { DocReceiptPDF } from "../pages/adminPortal/blform/DocReceiptPDF.jsx";
import BookingSchedule from "../pages/adminPortal/schedule/index.js";
import InvoiceReceiptPDF from "../pages/adminPortal/accounts/childfolder/InvoiceReceipt/InvoiceReceiptPDF.jsx";
import TermAndConditionCustomerPDF from "../pages/auth/TermAndConditionCustomerPDF.jsx";
import UserForm from "../pages/adminPortal/staff/user/Form.jsx";
import ViewUser from "../pages/adminPortal/staff/user/View.jsx";
import Notification from "../pages/adminPortal/notification/index.js";
import Drivers from "../pages/adminPortal/drivers/index.js";
import DriverForm from "../pages/adminPortal/drivers/Form.jsx";
import ViewDriver from "../pages/adminPortal/drivers/View.jsx";
import RateSending from "../pages/adminPortal/rate-sending/index.js";
import RateSendingForm from "../pages/adminPortal/rate-sending/Form.jsx";
import ViewCustomerVehicle from "../pages/customerPortal/customervehicle/ViewCustomerVehicle.jsx";
import CustomerViewAppointments from "../pages/customerPortal/customerappointment/CustomerViewAppointment.jsx";
import CustomerViewInvoice from "../pages/customerPortal/customerinvoices/CustomerViewInvoice.jsx";
import CustomerSupport from "../pages/customerPortal/customershelp";
import CustomerKnowledge from "../pages/customerPortal/customershelp/CustomerKnowledge.jsx";
import InvoicePdf from "../pages/customerPortal/customerinvoices/InvoicePdf.jsx";
import ViewLoadPlan from "../pages/customerPortal/customerloadingplan/ViewLoadPlan.jsx";
import Feedback from "../components/Feedback.jsx";
import AdminFeedback from "../pages/adminPortal/headericon/AdminFeedback.jsx";
import Chat from "../pages/adminPortal/chatsytem/index.js";
import FinalLayout from "../layout/index.js";
import Video from "../pages/adminPortal/video/index.js";
import OperationDashboard from "../pages/adminPortal/Dashboard/OperationDashboard.jsx";
import TermAndConditionCustomer from "../pages/auth/TermAndConditionCustomer.jsx";
import Tickers from "../pages/adminPortal/tickers/index.js";
import CustomerBannerForm from "../pages/adminPortal/customerbanner/CustomerBanner.jsx";
import CustomerBanners from "../pages/adminPortal/customerbanner/index.js";

const AuthRedirect = ({ destination }) => {
  const location = useLocation();
  return <Navigate to={destination} replace state={{ from: location }} />;
};

const wrapper = (Layout = null, title = null, Component) => {
  let accessToken = localStorage.getItem("token");

  const redirect = <AuthRedirect destination={"/login"} />;

  if (accessToken == null || !accessToken) return redirect;
  return <Layout title={title}>{Component}</Layout>;
}

function Navigation() {
  const [userRole, setUserRole] = useState(
    localStorage.getItem("role") ?? null
  );

  const [isAllowed, setIsAllowed] = useState(localStorage.getItem("isAllowed") ?? null);

  const [loginKey, setLoginKey] = useState(0);
  const [permissionKey, setPermissionKey] = useState(0);

  const isAdmin = userRole === ROLES.ADMIN || userRole === ROLES.EMPLOYEE;

  useEffect(() => {
    setUserRole(localStorage.getItem("role"));
  }, [loginKey]);

  useEffect(() => {
    setIsAllowed(localStorage.getItem("isAllowed"));
  }, [permissionKey]);

  const handleLogin = () => {
    setLoginKey((key) => key + 1);
  };

  const handlePermission = () => {
    setPermissionKey((key) => key + 1);
  }

  const handleComponent = (AdminComponent = null, CustomerComponent = null, DriverComponent = null) => {

    if (isAdmin && AdminComponent) {
      return <AdminComponent />;
    }

    if (userRole === ROLES.DRIVER && DriverComponent) {
      return <DriverComponent />
    }

    if (userRole === ROLES.CUSTOMER && CustomerComponent) {
      if (isAllowed === 'false') {
        return <Navigate to="/term-&-condition" replace />;
      }
      return <CustomerComponent />;
    }

    return "NotFound";
  };

  const customerRoute = () => {
    return (
      <>
        {/* <Route path="/vehicles" element={wrapper(FinalLayout, "Vehicles", handleComponent(null, CustomerVechical))} /> */}
        <Route path="/ledger" element={wrapper(FinalLayout, "Ledger", handleComponent(null, CustomerLedger))} />

        <Route path="/customers-portal/appointments" element={wrapper(FinalLayout, "Appointments", handleComponent(null, CustomerAppointments))} />
        <Route path="/customers-portal/appointments/view/:id?" element={wrapper(FinalLayout, 'Appointments', handleComponent(null, CustomerViewAppointments))} />
        <Route path="/customers-portal/appointments/add-appointments" element={wrapper(FinalLayout, "Appointments", handleComponent(null, AddAppointment))} />

        {/* <Route path="/invoice" element={wrapper(FinalLayout, "Invoices", handleComponent(CustomerInvoices))} /> */}
        {/* <Route path="/customers-portal/customer-invoices-view/:id?" element={wrapper(FinalLayout, "", handleComponent(null, CustomerViewInvoice))} />
        <Route path="/customers-portal/invoice/view/:id?" element={wrapper(FinalLayout, '', handleComponent(null, CustomerViewInvoice))} /> */}

        <Route path="/customers-portal/customer-invoices-PDF/:id?" element={wrapper(FinalLayout, "", handleComponent(null, InvoicePdf))} />

        <Route path="/edit-profiles" element={wrapper(FinalLayout, '', handleComponent(EditProfile, EditProfile, EditProfile))} />

        <Route path="/notifications" element={wrapper(FinalLayout, handleComponent(Notification, Notification))} />

        <Route path="/customers-portal/load-plan/create-load-plans" element={wrapper(FinalLayout, "Loading Plan", handleComponent(null, CreateLoadPlans))} />
        <Route path="/customers-portal/load-plan/open-save-plan" element={wrapper(FinalLayout, "Loading Plan", handleComponent(null, OpenSaveplan))} />
        <Route path="/customers-portal/load-plan/send-load-plan" element={wrapper(FinalLayout, "Loading Plan", handleComponent(null, SendLoadPlan))} />
        <Route path="/customers-portal/load-plan/loaded-plan" element={wrapper(FinalLayout, "Loading Plan", handleComponent(null, Loadedplan))} />
        <Route path="/customers-portal/load-plan/views/:id?" element={wrapper(FinalLayout, '', handleComponent(null, ViewLoadPlan))} />

        <Route path="/customers-portal/atvechile" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, AtVehicle))} />
        <Route path="/customers-portal/atvehicle-without-key" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, AtVehicleWithoutKey))} />
        <Route path="/customers-portal/atvehicle-without-title" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, AtVehicleWithoutTitle))} />
        <Route path="/customers-portal/loaded-vehicle" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, LoadedVehicle))} />
        <Route path="/customers-portal/other-vehicles" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, OtherVehicles))} />
        <Route path="/customers-portal/vehicle-loadplan" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, VehicleLoadPlan))} />
        <Route path="/customers-portal/vehicle-with-bos" element={wrapper(MainLayout, "Dashbaord", handleComponent(null, VehicleWithBOS))} />

        {/* <Route path="/ledger" element={wrapper(MainLayout, "Ledger", handleComponent(null, Ledger))} /> */}

      </>
    )
  }

  return (
    <Router>

      <Routes>
        <Route path="/" element={wrapper(FinalLayout, '', handleComponent(Dashboard, CustomerDashbroad, AddAppointment))} />

        {customerRoute()}
        <Route path="/management-dashboard" element={wrapper(FinalLayout, '', handleComponent(OperationDashboard))} />
        <Route path="/operation-dashboard" element={wrapper(FinalLayout, '', handleComponent(OperationDashboard))} />
        <Route path="/account-dashboard" element={wrapper(FinalLayout, '', handleComponent(OperationDashboard))} />

        <Route path="/help-center/support" element={wrapper(FinalLayout, "Help Center / Support", handleComponent(CustomerSupport, CustomerSupport))} />
        <Route path="/help-center/knowledge-base" element={wrapper(FinalLayout, "", handleComponent(CustomerKnowledge, CustomerKnowledge))} />
        <Route path="/help-center/feedback" element={wrapper(FinalLayout, "", handleComponent(Feedback, Feedback))} />

        {/* auth */}
        <Route path="/login" element={<AuthLayout><Login onLogin={handleLogin} /></AuthLayout>} />
        <Route path="/signup" element={<AuthLayout><Signup /></AuthLayout>} />
        <Route path="/forgot-password" element={<AuthLayout><Forget /></AuthLayout>} />
        <Route path="/reset-password/:token?" element={<AuthLayout><ResetPassword /></AuthLayout>} />

        {/* dashboard  */}
        <Route path="/term-&-condition" element={<TermAndCondition onSubmit={handlePermission} />} />
        <Route path="/feedback" element={wrapper(FinalLayout, "Feedback", handleComponent(AdminFeedback))} />
        <Route path="/video" element={wrapper(FinalLayout, "Video", handleComponent(Video))} />
        <Route path="/tickers" element={wrapper(FinalLayout, "Tickers", handleComponent(Tickers))} />
        <Route path="/chat" element={wrapper(FinalLayout, "Chat", handleComponent(Chat))} />
        <Route path="/customers-portal/term-&-conditions/:id?" element={<TermAndConditionCustomerPDF />} />
        <Route path="/customers-portal/term-&-condition/:id?" element={<TermAndConditionCustomer />} />

        <Route path="/" element={wrapper(FinalLayout, 'Dashboard', handleComponent(Dashboard, null, AddAppointment))} />

        {/* vehicle */}
        <Route path="/vehicle" element={wrapper(FinalLayout, "Vehicles", handleComponent(Vechical, CustomerVechical))} />
        <Route path="/vehicle/:id?" element={wrapper(FinalLayout, "", handleComponent(ViewCustomerVehicle, ViewCustomerVehicle))} />

        <Route path="/vehicle/add" element={wrapper(FinalLayout, "Vehicles", handleComponent(AddVehicle))} />
        <Route path="/vehicle/edit/:id?" element={wrapper(FinalLayout, "Edit Vehicles", handleComponent(VehicleEdit))} />
        {/* <Route path="/operation/vehicles/view/:id?" element={wrapper(MainLayout, "Vehicles", handleComponent(ViewVehicle))} /> */}
        {/* <Route path="/operations/vehicle/view/:id?" element={wrapper(FinalLayout, "Vehicles", handleComponent(ViewVehicle))} /> */}

        {/* customer  */}
        <Route path="/operations/customer" element={wrapper(FinalLayout, 'Customers', handleComponent(Customer))} />
        <Route path="/operations/customer/form/:id?" element={wrapper(FinalLayout, 'Customers', handleComponent(CustomerForm))} />
        <Route path="/operations/customer/view/:id?" element={wrapper(FinalLayout, 'View Customer', handleComponent(ViewCustomer))} />


        {/*customer Banner*/}

        <Route path="/banner" element={wrapper(FinalLayout, 'Customers Banner', handleComponent(CustomerBanners))} />
        <Route path="/banner/form" element={wrapper(FinalLayout, 'Customers Banner', handleComponent(CustomerBannerForm))} />

        {/* drivers */}
        <Route path="/operations/driver" element={wrapper(FinalLayout, 'Drivers', handleComponent(Drivers))} />
        <Route path="/operations/driver/form/:id?" element={wrapper(FinalLayout, 'Driver', handleComponent(DriverForm))} />
        <Route path="/operations/driver/view/:id?" element={wrapper(FinalLayout, 'Driver', handleComponent(ViewDriver))} />

        {/* bl-form  */}
        <Route path="/operations/bl-forms" element={wrapper(FinalLayout, 'BL Forms', handleComponent(BlForm))} />
        <Route path="/operations/bl-forms/edit/:id?" element={wrapper(FinalLayout, 'Blform', handleComponent(Edit))} />
        <Route path="/operations/bl-forms/add/:id?" element={wrapper(FinalLayout, 'Create BL Form', handleComponent(Add))} />
        <Route path="/operations/bl-forms/view/:id?" element={wrapper(FinalLayout, 'DockRecipt', handleComponent(DockReceipt))} />
        <Route path="/operations/bl-forms/pdf/:id?" element={<DocReceiptPDF />} />

        {/*  quotation */}
        <Route path="/operations/quotation" element={wrapper(FinalLayout, 'Quotation', handleComponent(Quotation))} />
        <Route path="/operations/quotation/view/:id?" element={wrapper(FinalLayout, 'Quotation', handleComponent(QuotationView))} />
        <Route path="/operations/quotation/form/:id?" element={wrapper(FinalLayout, 'Quotation', handleComponent(QuotationForm))} />

        {/*  rate-sending */}
        <Route path="/operations/rate-sending" element={wrapper(FinalLayout, 'Rate Sending', handleComponent(RateSending))} />
        <Route path="/operations/rate-sending/form/:id?" element={wrapper(FinalLayout, 'Rate Sending Form', handleComponent(RateSendingForm))} />

        {/* vendor */}
        <Route path="/operations/vendor" element={wrapper(FinalLayout, 'Vendors', handleComponent(Vendors))} />
        <Route path="/operations/vendor/form/:id?" element={wrapper(FinalLayout, 'Vendors', handleComponent(VendorForm))} />
        <Route path="/operations/vendor/view/:id?" element={wrapper(FinalLayout, 'Vendors', handleComponent(ViewVendor))} />

        {/* vendorQuotation */}
        <Route path="/operations/vendor/quotation" element={wrapper(FinalLayout, 'Browse Vendors Quotation', handleComponent(BrowseVendor))} />
        <Route path="/operations/vendor/quotation/views/:id?" element={wrapper(FinalLayout, 'Vendor Quotation', handleComponent(VendorQuotation))} />
        <Route path="/operations/vendor/quotation/form/:id?" element={wrapper(FinalLayout, 'Vendor Quotation', handleComponent(VendorQuotationForm))} />

        {/* report */}
        <Route path="/accounts/reports" element={wrapper(FinalLayout, 'Reports', handleComponent(Reports))} />
        <Route path="/accounts/reports/monthly_cash_flow/:month" element={wrapper(FinalLayout, "", handleComponent(MonthlyCashFlow))} />

        <Route path="/operations/bookings-schedules" element={wrapper(FinalLayout, "Booking Schedule", handleComponent(BookingSchedule))} />

        {/* employee */}
        <Route path="/administrations/employees" element={wrapper(FinalLayout, 'Employees', handleComponent(Employees))} />
        <Route path="/administrations/employees/form/:id?" element={wrapper(FinalLayout, 'Employees', handleComponent(EmployeeForm))} />
        <Route path="/administrations/employees/view/:id?" element={wrapper(FinalLayout, 'Employees', handleComponent(ViewEmployee))} />

        {/* towing */}
        <Route path="/operations/tariffs" element={wrapper(FinalLayout, 'Towing Tariff', handleComponent(TowingTariff))} />

        {/* Acounts */}
        <Route path="/accounts" element={wrapper(FinalLayout, 'Accounts', handleComponent(Accounts))} />
        <Route path="/accounts/opening-balances" element={wrapper(FinalLayout, 'Accounts', handleComponent(OpeningBalances))} />
        <Route path="/accounts/opening-balances/edit/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(EditOpeningBalances))} />
        <Route path="/accounts/cash-voucher" element={wrapper(FinalLayout, 'Accounts', handleComponent(CashVoucher))} />
        <Route path="/accounts/bank-voucher" element={wrapper(FinalLayout, 'Accounts', handleComponent(BankVoucher))} />
        <Route path="/accounts/journal-voucher" element={wrapper(FinalLayout, 'Accounts', handleComponent(JournalVoucher))} />
        <Route path="/accounts/browse-transaction" element={wrapper(FinalLayout, 'Accounts', handleComponent(BrowseTranscation))} />
        <Route path="/accounts/credit-notes" element={wrapper(FinalLayout, 'Accounts', handleComponent(CreditNotes))} />
        <Route path="/accounts/credit-notes/PDF/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(CreditPDF))} />
        <Route path="/accounts/debit-notes" element={wrapper(FinalLayout, 'Accounts', handleComponent(DebitNotes))} />
        <Route path="/accounts/debit-notes/PDF/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(DebitPDF))} />
        <Route path="/accounts/receipt-collects" element={wrapper(FinalLayout, 'Accounts', handleComponent(ReceiptCollect))} />
        <Route path="/accounts/receipt-collects/add" element={wrapper(FinalLayout, 'Accounts', handleComponent(AddRecepit))} />
        <Route path="/accounts/receipt-collects/PDF/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(InvoiceReceiptPDF))} />
        <Route path="/accounts/costings" element={wrapper(FinalLayout, 'Accounts', handleComponent(Coasting))} />
        <Route path="/accounts/costings/edit/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(AddCoastngExpenses))} />
        <Route path="/accounts/customer-ledgers" element={wrapper(FinalLayout, 'Accounts', handleComponent(AccountsCustomerLedger))} />
        <Route path="/accounts/payment-vouchers" element={wrapper(FinalLayout, 'Accounts', handleComponent(PaymentVoucher))} />
        <Route path="/accounts/payment-vouchers/PDF/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(PaymentPDF))} />
        <Route path="/accounts/expense-vouchers" element={wrapper(FinalLayout, 'Accounts', handleComponent(ExpenseVoucher))} />
        <Route path="/accounts/expense-vouchers/PDF/:id?" element={wrapper(FinalLayout, 'Accounts', handleComponent(VoucherPDF))} />
        <Route path="/accounts/vendor-payment-lists" element={wrapper(FinalLayout, 'Accounts', handleComponent(VendorPaymentList))} />
        <Route path="/accounts/vendor-container-payments" element={wrapper(FinalLayout, 'Accounts', handleComponent(VendorContainerPayment))} />
        <Route path="/accounts/ledger" element={wrapper(FinalLayout, 'Ledger', handleComponent(Ledger))} />
        <Route path="/accounts/PNL" element={wrapper(FinalLayout, 'PNL', handleComponent(PNL))} />
        <Route path="/accounts/chart-account/capital" element={wrapper(FinalLayout, 'Accounts', handleComponent(Capital))} />

        {/* setting */}
        <Route path="administrations/settings" element={wrapper(FinalLayout, 'Settings', handleComponent(Setting))} />
        <Route path="administrations/settings/containers" element={wrapper(FinalLayout, 'Settings', handleComponent(ContainerSize))} />
        <Route path="administrations/settings/logs" element={wrapper(FinalLayout, 'Settings', handleComponent(Log))} />

        {/* invoice */}
        <Route path="/invoice" element={wrapper(FinalLayout, 'Invoices', handleComponent(Invoice, CustomerInvoices))} />
        <Route path="/invoice/add" element={wrapper(FinalLayout, 'Invoices', handleComponent(AddInvoice))} />
        {/* <Route path="/invoice/edit/:id?" element={wrapper(FinalLayout, 'Invoices', handleComponent(EditInvoice))} /> */}
        <Route path="/invoice/pdf/:id?" element={wrapper(FinalLayout, 'Invoices', handleComponent(InvoiceView, InvoiceView))} />
        <Route path="/invoice/view/:id?" element={wrapper(FinalLayout, '', handleComponent(CustomerViewInvoice, CustomerViewInvoice))} />

        {/*  loadingplan */}
        <Route path="/operations/loadings" element={wrapper(FinalLayout, 'Loading Plan', handleComponent(LoadingPlan))} />

        <Route path="/operations/loadings/edits/:id?" element={wrapper(FinalLayout, 'Edit Loaded Plan', handleComponent(EditLoadingPlan))} />
        <Route path="/operations/loadings/pdf/:id?" element={wrapper(FinalLayout, '', handleComponent(LoadPlanPdf))} />
        <Route path="/operations/loadings/views/:id?" element={wrapper(FinalLayout, '', handleComponent(ViewLoadPlan))} />

        {/* loadingimo */}
        <Route path="/operations/loadings/imo" element={wrapper(FinalLayout, 'Loading IMO', handleComponent(LoadingImo))} />
        <Route path="/operations/loadings/imo/edit/:id?" element={wrapper(FinalLayout, 'Loading IMO', handleComponent(ImoEdit))} />
        <Route path="/operations/loadings/imo/view/:id?" element={wrapper(FinalLayout, 'Loading IMO', handleComponent(ImoView))} />

        {/* LoadingAdd */}
        <Route path="/operations/loadings/add" element={wrapper(FinalLayout, 'Loading Plan', handleComponent(LoadingAdd))} />

        {/* loadingclient */}
        <Route path="/operations/loadings/clients/views/:id?" element={wrapper(FinalLayout, 'View Loaded Plan Booking', handleComponent(ViewLoadingPlan))} />
        <Route path="/operations/loadings/clients" element={wrapper(FinalLayout, 'Loading Plan', handleComponent(LoadingClient))} />

        {/* loadingsaveconatiner */}
        <Route path="/operations/loadings/save-containers" element={wrapper(FinalLayout, 'Loading Plan', handleComponent(SaveContainer))} />
        <Route path="/operations/loadings/save-containers/views/:id?" element={wrapper(FinalLayout, '', handleComponent(ViewLoadPlan))} />
        <Route path="/operations/loadings/save-containers/edits/:id?" element={wrapper(FinalLayout, 'Edit Saved Plan', handleComponent(EditSavePlan))} />

        <Route path="/operations/loadings/generates-plans/:id?" element={wrapper(FinalLayout, "Generate Load Plan PDF", handleComponent(GenerateLoadPlan))} />
        <Route path="/operations/loadings/vehicle-details/:id?" element={wrapper(FinalLayout, "Offloaded Container", handleComponent(LoadingVehicleDetail, LoadingVehicleDetail))} />

        {/* header */}
        <Route path="/emails" element={wrapper(FinalLayout, 'Email', handleComponent(Email))} />
        {/* <Route path="/edit-profiles" element={wrapper(MainLayout, 'Edit Profile', handleComponent(EditProfile, EditProfile, EditProfile))} /> */}

        {/* appointments */}
        <Route path="/operations/appointment" element={wrapper(FinalLayout, 'Appointments', handleComponent(Appointments, null, Appointments))} />
        <Route path="/operations/appointment/add" element={wrapper(FinalLayout, 'Appointments', handleComponent(AddAppointment, null, AddAppointment))} />
        <Route path="/operations/appointment/view/:id?" element={wrapper(FinalLayout, 'Appointments', handleComponent(ViewAppointments, null, ViewAppointments))} />

        {/* invetoryReport */}
        <Route path="/operations/inventoryreport" element={wrapper(FinalLayout, 'Inventory Report', handleComponent(InventoryReport))} />

        {/* Staff */}
        <Route path="/staff/user" element={wrapper(FinalLayout, 'Employees', handleComponent(User))} />
        <Route path="/staff/user/form/:id?" element={wrapper(FinalLayout, 'Employees', handleComponent(UserForm))} />
        <Route path="/staff/user/view/:id?" element={wrapper(FinalLayout, 'Employees', handleComponent(ViewUser))} />
        <Route path="/staff/customer" element={wrapper(FinalLayout, 'Customer', handleComponent(StaffCustomer))} />
        <Route path="/staff/role" element={wrapper(FinalLayout, 'Roles', handleComponent(Role))} />
        <Route path="/staff/role/permissions/:id?" element={wrapper(FinalLayout, 'Permissions', handleComponent(Permissions))} />

      </Routes>
    </Router>
  );
}
export default Navigation